"use client";

import React from "react";

const developers = [
  { name: "DEVKRUPA", image: "devkrupa.jpg" },
  { name: "GIRIRAJ-GROUP", image: "GIRIRAJ-GROUP.png" },
  { name: "HB-REALTY", image: "HB-REALTY.png" },
  { name: "MASS-REALTY", image: "MASS-REALTY.png" },
  { name: "MOKAL", image: "mokal.webp" },
  { name: "OMKARA", image: "OMKARA.png" },
  { name: "PUSHPAK-ENTERPRISES", image: "PUSHPAK-ENTERPRISES.webp" },
  { name: "RACHANA-LIFESPACE", image: "RACHANA-LIFESPACE.png" },
  { name: "RUDRA-REALTY", image: "RUDRA-REALTY.png" },
  { name: "SAMBHAVE-GROUP", image: "SAMBHAVE-GROUP.webp" },
  { name: "SHREE-SAWAN-GROUP", image: "SHREE-SAWAN-GROUP.png" },
  { name: "THARWANI", image: "THARWANI.png" },
  { name: "Siddhivinayak Homes", image: "siddhivinayak-logo.png" },
];

const row1 = developers.slice(0, 6);
const row2 = developers.slice(6, 13);

const DeveloperCollaboration = () => {
  return (
    <section className="py-12 bg-white">
      <style>{`
        @keyframes scrollLeft {
          0% { transform: translateX(0%); }
          100% { transform: translateX(-50%); }
        }
        @keyframes scrollRight {
          0% { transform: translateX(-50%); }
          100% { transform: translateX(0%); }
        }
        .scroll-left {
          animation: scrollLeft 30s linear infinite;
        }
        .scroll-right {
          animation: scrollRight 30s linear infinite;
        }
        .scroll-left:hover,
        .scroll-right:hover {
          animation-play-state: paused;
        }
      `}</style>

      <div className="text-center mb-10">
        <h2 className="text-3xl md:text-4xl font-bold text-[#741112] mb-4">
         Developers Who’ve Achieved Success with Us
        </h2>
        <p className="text-gray-700 max-w-2xl mx-auto">
         We’re proud to work with visionary developers who trust us to drive sales, amplify reach, and deliver real success project after project.
        </p>
      </div>

      <div className="overflow-hidden mb-8">
        <div className="flex scroll-left whitespace-nowrap w-max">
          {[...row1, ...row1].map((dev, index) => (
            <div
              key={`left-${index}`}
              className="w-32 sm:w-40 md:w-52 mx-3 md:mx-6 text-center flex-shrink-0 relative group"
            >
              <div className="bg-white rounded-lg shadow p-2 md:p-4 h-28 sm:h-36 md:h-44 flex items-center justify-center relative overflow-hidden">
  <img
    src={`/assets/logo/${dev.image}`}
    alt={dev.name}
    className="max-h-full max-w-full object-contain transition duration-300"
  />
  <div className="hidden md:flex absolute inset-0 bg-black bg-opacity-60 text-white items-center justify-center opacity-0 group-hover:opacity-100 transition duration-300 rounded-lg">
    <span className="text-sm md:text-base font-semibold px-2 text-center">
      {dev.name}
    </span>
  </div>
</div>

            </div>
          ))}
        </div>
      </div>

      <div className="overflow-hidden">
        <div className="flex scroll-right whitespace-nowrap w-max">
          {[...row2, ...row2].map((dev, index) => (
            <div
              key={`right-${index}`}
              className="w-32 sm:w-40 md:w-52 mx-3 md:mx-6 text-center flex-shrink-0 relative group"
            >
              <div className="bg-white rounded-lg shadow p-2 md:p-4 h-28 sm:h-36 md:h-44 flex items-center justify-center relative overflow-hidden">
  <img
    src={`/assets/logo/${dev.image}`}
    alt={dev.name}
    className="max-h-full max-w-full object-contain transition duration-300"
  />
  <div className="hidden md:flex absolute inset-0 bg-black bg-opacity-60 text-white items-center justify-center opacity-0 group-hover:opacity-100 transition duration-300 rounded-lg">
    <span className="text-sm md:text-base font-semibold px-2 text-center">
      {dev.name}
    </span>
  </div>
</div>

            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DeveloperCollaboration;
